import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14cfc33c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "task-details position-relative"
}
const _hoisted_6 = { class: "container row m-0 p-1" }
const _hoisted_7 = {
  key: 0,
  class: "col-11 my-1 ps-4 ms-1"
}
const _hoisted_8 = {
  key: 1,
  class: "col-11 my-1 ps-4 ms-1"
}
const _hoisted_9 = {
  key: 2,
  class: "col-11 my-1 ps-4 ms-1"
}
const _hoisted_10 = { class: "d-flex col-12 mb-3 justify-content-center align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "col-3 form-group"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "task-name" }, " Task: ", -1 /* HOISTED */))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 1,
  class: "col-3 form-group"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "task-name" }, " Non-Visit Activity: ", -1 /* HOISTED */))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "form-group form-check custom-checkbox col-3 mt-4 ps-5" }
const _hoisted_20 = {
  key: 0,
  class: "pe-5"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "billable"
}, " Billable ", -1 /* HOISTED */))
const _hoisted_23 = {
  key: 1,
  class: "pe-5"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "paidStatus"
}, " Paid Status ", -1 /* HOISTED */))
const _hoisted_26 = { class: "" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "payable"
}, " Payable ", -1 /* HOISTED */))
const _hoisted_29 = { class: "col-3 form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "travel-start-time" }, " Travel Start Time: ", -1 /* HOISTED */))
const _hoisted_31 = { class: "input-group flex-nowrap" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "col-3 form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "travel-end-time" }, " Travel End Time: ", -1 /* HOISTED */))
const _hoisted_35 = { class: "input-group flex-nowrap" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "d-flex col-12 mb-3 justify-content-center align-items-center" }
const _hoisted_38 = {
  key: 0,
  class: "col-3 form-group"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "schedule-date" }, " Schedule Date: ", -1 /* HOISTED */))
const _hoisted_40 = { class: "input-group flex-nowrap" }
const _hoisted_41 = { class: "input-group date datepickerInput" }
const _hoisted_42 = ["value", "disabled"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */))
const _hoisted_44 = {
  key: 1,
  class: "col-3 form-group"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "schedule-date" }, " NVA Date: ", -1 /* HOISTED */))
const _hoisted_46 = { class: "input-group flex-nowrap" }
const _hoisted_47 = { class: "input-group date datepickerInput" }
const _hoisted_48 = ["value"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */))
const _hoisted_50 = {
  key: 2,
  class: "col-3 form-group"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "actual-date" }, " Actual Date: ", -1 /* HOISTED */))
const _hoisted_52 = { class: "input-group flex-nowrap" }
const _hoisted_53 = { class: "input-group date datepickerInput" }
const _hoisted_54 = ["value", "disabled"]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */))
const _hoisted_56 = {
  key: 3,
  class: "col-3 form-group"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "actual-date" }, " Paid Date: ", -1 /* HOISTED */))
const _hoisted_58 = { class: "input-group flex-nowrap" }
const _hoisted_59 = { class: "input-group date datepickerInput" }
const _hoisted_60 = ["value", "disabled"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */))
const _hoisted_62 = { class: "form-group col-3" }
const _hoisted_63 = { for: "visit-start-time" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "form-group col-3" }
const _hoisted_66 = { for: "visit-end-time" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = {
  key: 0,
  class: "form-group col-3"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "status" }, " Status: ", -1 /* HOISTED */))
const _hoisted_70 = ["disabled"]
const _hoisted_71 = ["value"]
const _hoisted_72 = {
  key: 1,
  class: "form-group col-3"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "assigned-to-list" }, " Assigned To: ", -1 /* HOISTED */))
const _hoisted_74 = {
  key: 2,
  class: "form-group col-3"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "surcharge" }, " Surcharge: ", -1 /* HOISTED */))
const _hoisted_76 = ["disabled"]
const _hoisted_77 = { class: "form-group col-3" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "associated-mileage" }, " Associated Mileage: ", -1 /* HOISTED */))
const _hoisted_79 = ["disabled"]
const _hoisted_80 = {
  key: 3,
  class: "d-flex col-12 mb-3 justify-content-start align-items-center"
}
const _hoisted_81 = { class: "form-group col-3" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "service-location" }, " Service Location (Q Codes): ", -1 /* HOISTED */))
const _hoisted_83 = ["disabled"]
const _hoisted_84 = ["value"]
const _hoisted_85 = {
  key: 0,
  class: "form-group col-3"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "auto-calculated-travel-time" }, " Auto-Calculated Travel Time: ", -1 /* HOISTED */))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "auto-calculated-travel-time",
  type: "text",
  class: "form-control",
  "number-only": "",
  disabled: ""
}, null, -1 /* HOISTED */))
const _hoisted_88 = [
  _hoisted_86,
  _hoisted_87
]
const _hoisted_89 = {
  key: 1,
  class: "form-group col-3"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "auto-calculated-mileage" }, " Auto-Calculated Mileage ", -1 /* HOISTED */))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "auto-calculated-mileage",
  type: "text",
  class: "form-control",
  "number-only": "",
  disabled: ""
}, null, -1 /* HOISTED */))
const _hoisted_92 = [
  _hoisted_90,
  _hoisted_91
]
const _hoisted_93 = {
  key: 2,
  class: "form-group col-3"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "physician-name" }, " Physician ", -1 /* HOISTED */))
const _hoisted_95 = {
  key: 4,
  class: "d-flex col-12 mb-3 justify-content-start align-items-center"
}
const _hoisted_96 = {
  key: 0,
  class: "form-group col-3"
}
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "received-date" }, " Received Date: ", -1 /* HOISTED */))
const _hoisted_98 = { class: "input-group date datepickerInput" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */))
const _hoisted_101 = {
  key: 1,
  class: "form-group col-3"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "physician-signature-date" }, " Physician Signature Date: ", -1 /* HOISTED */))
const _hoisted_103 = { class: "input-group date datepickerInput" }
const _hoisted_104 = ["value", "disabled"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */))
const _hoisted_106 = { class: "form-group col-3" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "confirmation-status" }, " Confirmation Status ", -1 /* HOISTED */))
const _hoisted_108 = ["disabled"]
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Confirmation Status", -1 /* HOISTED */))
const _hoisted_110 = ["value"]
const _hoisted_111 = {
  key: 5,
  class: "d-flex col-12 mb-3 justify-content-start align-items-center"
}
const _hoisted_112 = { class: "form-group col-12" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "episode-selection" }, " Episode Selection ", -1 /* HOISTED */))
const _hoisted_114 = { class: "form-group form-check custom-checkbox col-11 mt-2 ms-3" }
const _hoisted_115 = ["disabled"]
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "another-episode"
}, " Check here to move visit/document to another episode ", -1 /* HOISTED */))
const _hoisted_117 = {
  key: 0,
  class: "form-group col-12 mt-2"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "episode-list" }, " Episode List: ", -1 /* HOISTED */))
const _hoisted_119 = ["disabled"]
const _hoisted_120 = ["value"]
const _hoisted_121 = { class: "d-flex flex-column col-12 p-2" }
const _hoisted_122 = { class: "form-group" }
const _hoisted_123 = {
  key: 0,
  for: "comments"
}
const _hoisted_124 = /*#__PURE__*/_createTextVNode(" Comments ")
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ms-2 fas fa-sticky-note yellow" }, null, -1 /* HOISTED */))
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" (Yellow Sticky Note) ")
const _hoisted_127 = [
  _hoisted_124,
  _hoisted_125,
  _hoisted_126
]
const _hoisted_128 = {
  key: 1,
  for: "comments"
}
const _hoisted_129 = {
  key: 6,
  class: "d-flex flex-column col-12 p-2"
}
const _hoisted_130 = { class: "form-group" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "return-reason" }, [
  /*#__PURE__*/_createTextVNode(" Return Reason "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sticky-note ms-2 red-note" }),
  /*#__PURE__*/_createTextVNode(" (Red Sticky Note) ")
], -1 /* HOISTED */))
const _hoisted_132 = { key: 0 }
const _hoisted_133 = { class: "d-flex justify-content-between" }
const _hoisted_134 = { class: "fw-bold" }
const _hoisted_135 = {
  key: 1,
  class: "p-2 mb-2 bg-white rounded border border-secondary"
}
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center fst-italic" }, "No Return Reason Found", -1 /* HOISTED */))
const _hoisted_137 = [
  _hoisted_136
]
const _hoisted_138 = {
  key: 7,
  class: "d-flex flex-column col-12 p-2"
}
const _hoisted_139 = { class: "form-group" }
const _hoisted_140 = {
  key: 0,
  class: "d-flex justify-content-center mb-3 position-sticky bg-background-home-health-form-section p-2 z-index-10 bottom-0"
}
const _hoisted_141 = { key: 0 }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */))
const _hoisted_143 = [
  _hoisted_142
]
const _hoisted_144 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimePicker = _resolveComponent("TimePicker")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_VisitAttachmentsHH = _resolveComponent("VisitAttachmentsHH")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_FormSection, {
      title: _ctx.visitDetails.TaskName,
      "full-height": false,
      "application-id": _ctx.visitDetails.Application,
      "show-product-pill": true
    }, {
      content: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
          : (_openBlock(), _createElementBlock("section", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.visitDetails.isEmployeeCalendar && !_ctx.visitDetails.IsNonVisitAssignment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("b", null, "Patient Name: " + _toDisplayString(_ctx.visitDetails.PatientFirstName) + " " + _toDisplayString(_ctx.visitDetails.PatientLastName), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.visitDetails.IsNonVisitAssignment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("b", null, "User Name: " + _toDisplayString(_ctx.scheduleEvent.userFirstName) + " " + _toDisplayString(_ctx.scheduleEvent.userLastName), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.visitDetails.IsNonVisitAssignment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("b", null, "Branch: " + _toDisplayString(_ctx.scheduleEvent.branchName), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_10, [
                  (!_ctx.visitDetails.IsNonVisitAssignment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _hoisted_12,
                        _withDirectives(_createElementVNode("select", {
                          id: "task-name",
                          class: "form-select",
                          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.disciplineTaskTypeChanged(_ctx.disciplineTaskType))),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.disciplineTaskType) = $event)),
                          disabled: _ctx.isPlanner
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskDetails.disciplineTasks, (task, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: task.value
                            }, _toDisplayString(task.text), 9 /* TEXT, PROPS */, _hoisted_14))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_13), [
                          [_vModelSelect, _ctx.disciplineTaskType]
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _withDirectives(_createElementVNode("select", {
                          id: "task-name",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nVATaskId) = $event)),
                          disabled: _ctx.isPlanner
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskDetails.disciplineTasks, (task, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: task.value
                            }, _toDisplayString(task.text), 9 /* TEXT, PROPS */, _hoisted_18))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_17), [
                          [_vModelSelect, _ctx.nVATaskId]
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_19, [
                    (!_ctx.visitDetails.IsNonVisitAssignment)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "billable",
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.scheduleEvent.isBillable) = $event)),
                            disabled: _ctx.isPlanner
                          }, null, 8 /* PROPS */, _hoisted_21), [
                            [_vModelCheckbox, _ctx.scheduleEvent.isBillable]
                          ]),
                          _hoisted_22
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "paidStatus",
                            class: "form-check-input",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scheduleEvent.paidStatus) = $event)),
                            disabled: _ctx.isPlanner
                          }, null, 8 /* PROPS */, _hoisted_24), [
                            [_vModelCheckbox, _ctx.scheduleEvent.paidStatus]
                          ]),
                          _hoisted_25
                        ])),
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "payable",
                        class: "form-check-input",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.scheduleEvent.isPayable) = $event)),
                        disabled: _ctx.isPlanner || _ctx.visitDetails.IsNonVisitAssignment
                      }, null, 8 /* PROPS */, _hoisted_27), [
                        [_vModelCheckbox, _ctx.scheduleEvent.isPayable]
                      ]),
                      _hoisted_28
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_TimePicker, {
                          id: "travel-start-time",
                          onUpdateProps: _ctx.changeTravelStartTime
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              placeholder: "hh:mm AM",
                              class: _normalizeClass(`form-control`),
                              type: "text",
                              autocomplete: "off",
                              maxlength: "8",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scheduleEvent.travelTimeIn) = $event)),
                              disabled: _ctx.isPlanner
                            }, null, 8 /* PROPS */, _hoisted_32), [
                              [_vModelText, _ctx.scheduleEvent.travelTimeIn]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onUpdateProps"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_TimePicker, {
                          id: "travel-end-time",
                          onUpdateProps: _ctx.changeTravelEndTime
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              placeholder: "hh:mm AM",
                              class: _normalizeClass(`form-control`),
                              type: "text",
                              autocomplete: "off",
                              maxlength: "8",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scheduleEvent.travelTimeOut) = $event)),
                              disabled: _ctx.isPlanner
                            }, null, 8 /* PROPS */, _hoisted_36), [
                              [_vModelText, _ctx.scheduleEvent.travelTimeOut]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onUpdateProps"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  (!_ctx.visitDetails.IsNonVisitAssignment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("input", {
                                  id: "schedule-date",
                                  type: "text",
                                  name: "scheduleDateTime",
                                  class: "form-control rounded-0 border-end-0",
                                  placeholder: "MM/DD/YYYY",
                                  value: _ctx.formatDate(_ctx.scheduleEvent.eventDate),
                                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleTypedDateChange && _ctx.handleTypedDateChange(...args))),
                                  disabled: !_ctx.areFieldsEnabled
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_42),
                                _hoisted_43
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["getDate"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("input", {
                                  id: "nva-date",
                                  type: "text",
                                  name: "nvaDateTime",
                                  class: "form-control rounded-0 border-end-0",
                                  placeholder: "MM/DD/YYYY",
                                  value: _ctx.formatDate(_ctx.scheduleEvent.nvaStartDate),
                                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleTypedDateChange && _ctx.handleTypedDateChange(...args)))
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_48),
                                _hoisted_49
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["getDate"])
                        ])
                      ])),
                  (!_ctx.visitDetails.IsNonVisitAssignment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("input", {
                                  id: "actual-date",
                                  type: "text",
                                  name: "actualDateTime",
                                  class: "form-control rounded-0 border-end-0",
                                  placeholder: "MM/DD/YYYY",
                                  value: _ctx.formatDate(_ctx.scheduleEvent.visitDate),
                                  onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleTypedDateChange && _ctx.handleTypedDateChange(...args))),
                                  disabled: !_ctx.areFieldsEnabled
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_54),
                                _hoisted_55
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["getDate"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("input", {
                                  id: "nvapaid-date",
                                  type: "text",
                                  name: "nvaPaidDate",
                                  class: "form-control rounded-0 border-end-0",
                                  placeholder: "MM/DD/YYYY",
                                  value: 
                                                    _ctx.formatDate(
                                                        _ctx.scheduleEvent.nvaPaidDate?.startsWith('0001-01-01')
                                                            ? null
                                                            : _ctx.scheduleEvent.nvaPaidDate
                                                    )
                                                ,
                                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleTypedDateChange && _ctx.handleTypedDateChange(...args))),
                                  disabled: !_ctx.areFieldsEnabled
                                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_60),
                                _hoisted_61
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["getDate"])
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.visitDetails.IsNonVisitAssignment ? "NVA Start Time:" : "Visit Time In:"), 1 /* TEXT */),
                    _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeVisitTimeIn }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          id: "visit-start-time",
                          type: "text",
                          class: "form-control",
                          autocomplete: "off",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.scheduleEvent.timeIn) = $event)),
                          placeholder: "hh:mm AM",
                          disabled: !_ctx.areFieldsEnabled
                        }, null, 8 /* PROPS */, _hoisted_64), [
                          [_vModelText, _ctx.scheduleEvent.timeIn]
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onUpdateProps"])
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.visitDetails.IsNonVisitAssignment ? "NVA End Time:" : "Visit Time Out:"), 1 /* TEXT */),
                    _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeVisitTimeOut }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "hh:mm AM",
                          id: "visit-end-time",
                          type: "text",
                          class: "form-control",
                          autocomplete: "off",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.scheduleEvent.timeOut) = $event)),
                          disabled: !_ctx.areFieldsEnabled
                        }, null, 8 /* PROPS */, _hoisted_67), [
                          [_vModelText, _ctx.scheduleEvent.timeOut]
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onUpdateProps"])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(
                                !_ctx.visitDetails.IsNonVisitAssignment
                                    ? 'd-flex col-12 mb-3 justify-content-center align-items-center'
                                    : 'd-flex col-12 mb-3 align-items-center'
                            )
                }, [
                  (!_ctx.visitDetails.IsNonVisitAssignment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _hoisted_69,
                        _withDirectives(_createElementVNode("select", {
                          class: "form-select",
                          id: "status",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.scheduleEvent.status) = $event)),
                          onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleChangeStatus(_ctx.scheduleEvent.status))),
                          disabled: _ctx.isPlanner || _ctx.visitDetails.IsNonVisitAssignment
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskDetails.statuses, (status, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: status.value,
                              key: index
                            }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_71))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_70), [
                          [_vModelSelect, _ctx.scheduleEvent.status]
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.visitDetails.IsNonVisitAssignment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _hoisted_73,
                        _createVNode(_component_TypeaheadInput, {
                          id: "assigned-to-list",
                          getData: _ctx.employeeListFilter,
                          value: _ctx.scheduleEmployee,
                          onValueChanged: _ctx.changescheduleEmployee,
                          placeholder: "Type to Select User",
                          "show-all-by-default": true,
                          "open-on-focus": true,
                          disabled: _ctx.isPlanner || _ctx.visitDetails.IsNonVisitAssignment
                        }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "disabled"])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.visitDetails.IsNonVisitAssignment)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _hoisted_75,
                        _withDirectives(_createElementVNode("input", {
                          id: "surcharge",
                          type: "text",
                          class: "form-control",
                          placeholder: "Enter Amount",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.scheduleEvent.surcharge) = $event)),
                          "number-only": "",
                          maxlength: "7",
                          disabled: _ctx.isPlanner || _ctx.visitDetails.IsNonVisitAssignment
                        }, null, 8 /* PROPS */, _hoisted_76), [
                          [_vModelText, _ctx.scheduleEvent.surcharge]
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _withDirectives(_createElementVNode("input", {
                      id: "associated-mileage",
                      type: "text",
                      class: "form-control",
                      placeholder: "Enter Amount",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.scheduleEvent.associatedMileage) = $event)),
                      "number-only": "",
                      maxlength: "7",
                      disabled: _ctx.isPlanner
                    }, null, 8 /* PROPS */, _hoisted_79), [
                      [_vModelText, _ctx.scheduleEvent.associatedMileage]
                    ])
                  ])
                ], 2 /* CLASS */),
                (!_ctx.visitDetails.IsNonVisitAssignment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _hoisted_82,
                        _withDirectives(_createElementVNode("select", {
                          id: "service-location",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.scheduleEvent.serviceLocation) = $event)),
                          onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.serviceLocationChange(_ctx.scheduleEvent.serviceLocation))),
                          disabled: _ctx.isPlanner || _ctx.visitDetails.IsNonVisitAssignment
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskDetails.serviceLocations, (location, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: location.value,
                              key: index
                            }, _toDisplayString(location.text), 9 /* TEXT, PROPS */, _hoisted_84))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_83), [
                          [_vModelSelect, _ctx.scheduleEvent.serviceLocation]
                        ])
                      ]),
                      (!_ctx.visitDetails.IsNonVisitAssignment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, _hoisted_88))
                        : _createCommentVNode("v-if", true),
                      (!_ctx.visitDetails.IsNonVisitAssignment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_89, _hoisted_92))
                        : _createCommentVNode("v-if", true),
                      (_ctx.showPhyicianField)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                            _hoisted_94,
                            _createVNode(_component_TypeaheadInput, {
                              id: "physician-name",
                              placeholder: "Start Typing",
                              getData: _ctx.getPhysicianList,
                              value: _ctx.physician,
                              initValue: _ctx.physician,
                              disabled: _ctx.isPlanner || _ctx.visitDetails.IsNonVisitAssignment
                            }, null, 8 /* PROPS */, ["getData", "value", "initValue", "disabled"])
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true),
                (!_ctx.visitDetails.IsNonVisitAssignment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                      (_ctx.isReturnedWithSignature)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                            _hoisted_97,
                            _createVNode(_component_DatePicker, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_98, [
                                  _createElementVNode("input", {
                                    id: "received-date",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "MM/DD/YYYY",
                                    "date-format-only": "",
                                    disabled: _ctx.isPlanner || _ctx.visitDetails.IsNonVisitAssignment
                                  }, null, 8 /* PROPS */, _hoisted_99),
                                  _hoisted_100
                                ])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]))
                        : _createCommentVNode("v-if", true),
                      (_ctx.isReturnedWithSignature())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                            _hoisted_102,
                            _createVNode(_component_DatePicker, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_103, [
                                  _createElementVNode("input", {
                                    id: "physician-signature-date",
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "MM/DD/YYYY",
                                    value: _ctx.scheduleEvent.physicianSignedDate,
                                    "date-format-only": "",
                                    disabled: _ctx.isPlanner || _ctx.visitDetails.IsNonVisitAssignment
                                  }, null, 8 /* PROPS */, _hoisted_104),
                                  _hoisted_105
                                ])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("div", _hoisted_106, [
                        _hoisted_107,
                        _withDirectives(_createElementVNode("select", {
                          id: "confirmation-status",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.confirmationStatus) = $event)),
                          disabled: !_ctx.areFieldsEnabled || _ctx.visitDetails.IsNonVisitAssignment
                        }, [
                          _hoisted_109,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.confirmationStatusEnum), ([index, status]) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: status.value,
                              key: status.value
                            }, _toDisplayString(status.name), 9 /* TEXT, PROPS */, _hoisted_110))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_108), [
                          [_vModelSelect, _ctx.confirmationStatus]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (!_ctx.visitDetails.IsNonVisitAssignment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                      _createElementVNode("div", _hoisted_112, [
                        _hoisted_113,
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              id: "another-episode",
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isEpisodeSelectionChecked) = $event)),
                              disabled: _ctx.isPlanner
                            }, null, 8 /* PROPS */, _hoisted_115), [
                              [_vModelCheckbox, _ctx.isEpisodeSelectionChecked]
                            ]),
                            _hoisted_116,
                            (_ctx.isEpisodeSelectionChecked)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                  _hoisted_118,
                                  _withDirectives(_createElementVNode("select", {
                                    id: "episode-list",
                                    class: "form-select",
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.scheduleEvent.episodeId) = $event)),
                                    onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onEpisodeListChange(_ctx.scheduleEvent.episodeId))),
                                    disabled: _ctx.isPlanner
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskDetails.patientEpisodes, (episode, index) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: index,
                                        value: episode.value
                                      }, _toDisplayString(episode.text), 9 /* TEXT, PROPS */, _hoisted_120))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_119), [
                                    [_vModelSelect, _ctx.scheduleEvent.episodeId]
                                  ])
                                ]))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("section", _hoisted_121, [
                  _createElementVNode("div", _hoisted_122, [
                    (!_ctx.visitDetails.IsNonVisitAssignment)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_123, _hoisted_127))
                      : (_openBlock(), _createElementBlock("label", _hoisted_128, " Comments ")),
                    _createVNode(_component_CommentInput, {
                      id: "comments",
                      "input-name": "referral-comments",
                      placeholder: "Enter Comments",
                      classList: _ctx.commentInputClass,
                      application: _ctx.visitDetails.Application,
                      onResultUpdatedAppended: _ctx.resultUpdatedAppended,
                      onResultUpdated: _ctx.resultUpdated,
                      showTemplateTypeahead: false,
                      showTemplateDropdown: false,
                      result: _ctx.scheduleEvent.comments,
                      disabled: _ctx.isPlanner
                    }, null, 8 /* PROPS */, ["classList", "application", "onResultUpdatedAppended", "onResultUpdated", "result", "disabled"])
                  ])
                ]),
                (!_ctx.visitDetails.IsNonVisitAssignment)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_129, [
                      _createElementVNode("div", _hoisted_130, [
                        _hoisted_131,
                        (_ctx.returnReasons.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.returnReasons, (reasonCode, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  _createElementVNode("div", _hoisted_133, [
                                    _createElementVNode("div", _hoisted_134, [
                                      _createTextVNode(_toDisplayString(reasonCode.user) + " ", 1 /* TEXT */),
                                      _createElementVNode("sup", null, [
                                        _createElementVNode("i", null, _toDisplayString(reasonCode.date), 1 /* TEXT */)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", null, _toDisplayString(reasonCode.reason), 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true),
                        (!_ctx.returnReasons.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_135, _hoisted_137))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (!_ctx.visitDetails.IsNonVisitAssignment)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_138, [
                      _createElementVNode("div", _hoisted_139, [
                        _createVNode(_component_VisitAttachmentsHH, {
                          visitDetails: _ctx.visitDetails,
                          isPlanner: _ctx.isPlanner
                        }, null, 8 /* PROPS */, ["visitDetails", "isPlanner"])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                    (_ctx.isSavingVisit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_141, _hoisted_143))
                      : _createCommentVNode("v-if", true),
                    (!_ctx.isSavingVisit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_144, [
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.updateVisitDetails()))
                          }, "Save"),
                          _createElementVNode("button", {
                            type: "button",
                            class: "ms-1 btn btn-md btn-outline-secondary",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.closeDialog()))
                          }, " Cancel ")
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title", "application-id"])
  ]))
}